import { GET } from "../../APiHelper/API";

export const getPlayers = (team_id, onSuccess, onError) => {


    GET(`/api/v1/leagues/team/${team_id}/players`, onSuccess, onError)
}